export const facebook = (partnersIds) => {
	!(function (f, b, e, v, n, t, s) {
		if (f.fbq) return
		n = f.fbq = function () {
			n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
		}
		if (!f._fbq) f._fbq = n
		n.push = n
		n.loaded = !0
		n.version = '2.0'
		n.queue = []
		t = b.createElement(e)
		t.async = !0
		t.src = v
		s = b.getElementsByTagName(e)[0]
		s.parentNode.insertBefore(t, s)
	})(window, document, 'script', '//connect.facebook.net/en_US/fbevents.js')
	
  Object.entries(partnersIds).forEach(([partnerId, partnerOptions]) => {
    fbq('init', partnerId)

    if ('events' in partnerOptions) {
      callPartnerIdFbqTracks(partnerId, partnerOptions.events)
    }
  })

  fbq('track', 'PageView')

  function callPartnerIdFbqTracks(partnerId, tracks) {
    Object.entries(tracks).forEach(([index, track]) => {
      if (track.type == 'purchase') {
        callPurchaseFbq(partnerId, track.params)
        return
      }

      if (track.type == 'checkout') {
        callCheckoutFbq(partnerId)
      }
    })
  }

  function callPurchaseFbq(partnerId, params) {
    fbq('trackSingle', partnerId, 'Purchase', {
      value: params.value,
      currency: params.currency,
    })
  }

  function callCheckoutFbq(partnerId) {
    fbq('trackSingle', partnerId, 'InitiateCheckout')
  }
	
}
